// extracted by mini-css-extract-plugin
export default {"heading":"UserManagementUsersDetailsForm_heading__Z5Znj","form":"UserManagementUsersDetailsForm_form__fxkWK"};